(() => {
    const omnitureClickedLiveAgentFromDesktop = 'HelpCenter.DefaultPage.ChatBot.Clicked';
    const omnitureClickedLiveAgentFromPanelContactPage = 'HelpCenter.Panel.Contact.ChatBot.Clicked';
    const omnitureClickedLiveAgentFromPanelDefaultPage = 'HelpCenter.Panel.DefaultPage.ChatBot.Clicked';
    
    if (EG.bootstrapped && EG.bootstrapped.chatData) {
        const { chatBotOrCpEnabled, provider, newChatButton } = EG.bootstrapped.chatData

        window.openChat = function(e) {
            e && e.preventDefault();
            
            if (chatBotOrCpEnabled) {
                if (newChatButton) {
                    // Open SF bot from provider check
                    if("ENHANCED_SALESFORCE" === provider) {
                        if (!window.sfChat) {
                            if (e.target.getAttribute('disabled') === "true") return;
                            e.target.setAttribute('disabled', true);
                        }
                        if (EG.bootstrapped.isPanel) {
                            omnitureLog.logClickEvent(e.target.dataset.panelViewName == 'DefaultPage' ?
                                omnitureClickedLiveAgentFromPanelDefaultPage : omnitureClickedLiveAgentFromPanelContactPage);
                            window.parent.postMessage({'message': 'open-sfchat', 'launchPoint' : EG.pageName }, '*');
                        } else {
                            e.preventDefault();
                            omnitureLog.logClickEvent(omnitureClickedLiveAgentFromDesktop);
                            uitk.sfChatBot.openSfChat();
                        }
                    }
                }
            }
        }

        window.addEventListener('message', (e) => {
            if (e.data === 'SF_CHAT_LOAD_FAILED') {
                $('.btn-chat').removeAttr('disabled');

                const modal = uitk.modal.create({
                    modalId: 'vac-load-failed-modal',
                    content: `<p>${uitk.i18n.msg("uitk_vap_load_fail")}</p>`
                });
                modal.open();
            }
            if (e.data === 'SF_CHAT_PROCESSED') {
                $('.btn-chat').removeAttr('disabled');
            }
        })
    }

})()